<script setup>
import { watch } from "vue";
import ModalApp from "@/components/common/modal/ModalApp.vue";
import ButtonApp from "@/components/common/other/ButtonApp.vue";

defineProps({
  title: {
    type: String,
    default: "",
  },
  confirmLabel: {
    type: String,
    default: "Підтвердити",
  },
  confirmStyle: {
    type: String,
    default: "primary",
  },
  cancelLabel: {
    type: String,
    default: "Скасувати",
  },
});

const emit = defineEmits(["confirm", "cancel"]);

const isOpen = defineModel("isOpen", { type: Boolean, default: false });

let isConfirmed = false;

watch(isOpen, (open) => {
  if (open) {
    isConfirmed = false;
    return;
  }

  if (!isConfirmed) {
    emit("cancel");
  }
});

function confirm() {
  isConfirmed = true;
  isOpen.value = false;
  emit("confirm");
}

function close() {
  isOpen.value = false;
}
</script>

<template>
  <ModalApp v-model:is-open="isOpen" :title="title">
    <template #body>
      <slot />
    </template>

    <template #footer>
      <ButtonApp variant="secondary" :label="cancelLabel" @click="close" />
      <ButtonApp
        :variant="confirmStyle"
        :label="confirmLabel"
        @click="confirm"
      />
    </template>
  </ModalApp>
</template>
